export const PAYMENT_PARTIES = {
  client: {
    endpoint: "/project-finances/client-payments",
    invoicePath: (id) => `/client/invoice/${id}`,
    paymentPath: (id) => `/client/payment/${id}`,
    methodsUrl: () => "/project-finances/client-payments/form-options",
    pickMethods: (data) => data.payment_methods || [],
    partyLabel: "client",
  },
  vendor: {
    endpoint: "/project-finances/vendor-payments",
    invoicePath: (id) => `/vendor/invoice/${id}`,
    paymentPath: (id) => `/vendor/payment/${id}`,
    methodsUrl: (payment) => `/project-finances/vendor-payments/vendor-methods/${payment.vendor_id}`,
    pickMethods: (data) => data || [],
    partyLabel: "vendor",
  },
};

export const COVERAGE_CLS = {
  "Fully covered": "text-green-600 font-medium",
  Covered: "text-green-600 font-medium",
  "Partially covered": "text-amber-600 font-medium",
  "Not covered": "text-danger-500 font-medium",
};

export const fmtNum = (v) => Number(v || 0).toFixed(2);

export const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—";

// Invoice coverage as the invoice sees it: covered once nothing is due on it.
export const invoiceCoverage = (inv) =>
  inv.coverage_by_payments ||
  (Number(inv.due_amount) <= 0 ? "Covered" : Number(inv.paid_amount) > 0 ? "Partially covered" : "Not covered");

export const methodLabel = (m) => {
  const type = m.type?.replace(/_/g, " ");
  return m.name && m.name !== type ? `${m.name} (${type})` : type || m.name;
};
